import React from 'react';

type DownloadLinkProps = {
  children: React.ReactNode;
  className?: string;
  href: string;
  target?: string;
  fileName?: string;
};

const DownloadLink: React.FC<DownloadLinkProps> = (props: any) => {
  const { href, children, target, fileName, ...otherProps } = props;

  const getBlob = (url: string) => {
    return new Promise((resolve) => {
      const xhr = new XMLHttpRequest();

      xhr.open('GET', url, true);
      xhr.responseType = 'blob';
      xhr.onload = () => {
        if (xhr.status === 200) {
          resolve(xhr.response);
        }
      };

      xhr.send();
    });
  };

  const saveAs = (blob: any, filename: string) => {
    // @ts-ignore
    if (window?.navigator?.msSaveOrOpenBlob) {
      // @ts-ignore
      navigator.msSaveBlob(blob, filename);
    } else {
      const link = document.createElement('a');
      const body: any = document.getElementById(
        'beukay_preview_link',
      )?.parentElement;

      link.href = window.URL.createObjectURL(blob);
      link.download = filename;

      // fix Firefox
      link.style.display = 'none';
      if (target) link.target = target;
      body.appendChild(link);

      link.click();
      body.removeChild(link);

      window.URL.revokeObjectURL(link.href);
    }
  };

  const downloadUrl = () => {
    if (href) {
      const filename = fileName || href.replace(/(.*\/)*([^.]+).*/gi, '$2');
      getBlob(href).then((blob) => {
        saveAs(blob, filename);
      });
    }
  };

  return (
    <a id="beukay_preview_link" onClick={downloadUrl} {...otherProps}>
      {children}
    </a>
  );
};

export default DownloadLink;
